// Media URLs expire (see AttachmentUrl). When a player fails to load one, ask the server
// for a freshly signed URL instead of leaving the learner stuck.
//
// Retries once per failure only: a 404 here means "not your course", not "expired", and
// retrying that would loop.
const refreshFileUrl = async (courseId, lessonId) => {
  const response = await fetch(
    `/client/courses/${courseId}/lessons/${lessonId}/file_url`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    },
  );

  if (!response.ok) return null;

  const data = await response.json();

  return data.file_url;
};

export default refreshFileUrl;
